import { call, put } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import ApiYearlyFinancialYTD from '../../Api/ApiYearlyFinancialYTD';
import ToastMsg from '../../Components/ToastMsg';
import { creators as YearlyFinancialYTDActions } from '../../Reducers/Reporting/YearlyFinancialYTD';

export function* getYearlyFinancialYTDSummary({ payload }) {
  try {
    const response = yield call(
      ApiYearlyFinancialYTD.getSummary,
      payload.selectedYears,
    );

    if (response.status === 200) {
      yield put(
        YearlyFinancialYTDActions.yearlyytdSuccess({ summaryData: response.data }),
      );
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'Yearly Financial YTD Summary',
            text: response.message,
          },
        },
      );
      yield put(YearlyFinancialYTDActions.yearlyytdFailure(response.message));
    }
  } catch (e) {
    yield put(YearlyFinancialYTDActions.yearlyytdFailure(e));
  }
}

export function* getYearlyFinancialYTDDetail({ payload }) {
  try {
    const response = yield call(
      ApiYearlyFinancialYTD.getDetail,
      payload.selectedYears,
      payload.defaultYear,
      payload.defaultMonth,
      payload.DateKey,
    );

    if (response.status === 200) {
      yield put(
        YearlyFinancialYTDActions.yearlyytdSuccess({ detailData: response.data }),
      );
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'Yearly Financial YTD Detail',
            text: response.message,
          },
        },
      );
      yield put(YearlyFinancialYTDActions.yearlyytdFailure(response.message));
    }
  } catch (e) {
    yield put(YearlyFinancialYTDActions.yearlyytdFailure(e));
  }
}
